// import React from 'react';
import { styled } from '@mui/material/styles';
import { ModernSlaveryClobDto } from 'models/dtoTypes';
import SubSection from './_subSection';
import SdgScoreClob, { ISdgData } from './_sdgScoreClob';
import Empty from './_empty';
import EsgLegand from './_esgLegand';
import { useTranslation } from 'react-i18next';

const PREFIX = '_dualUseServicesReport';

const classes = {
  report: `${PREFIX}-report`,
};

const Root = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  [`& .${classes.report}`]: {},
}));

interface IProps {
  name?: string;
  modernSlaveryReport: ModernSlaveryClobDto[];
}

export default function ModernSlaveryReport(props: IProps): JSX.Element {
  const { t } = useTranslation('default');
  const { name = 'Modern Slavery: Child Labour and Forced Labour', modernSlaveryReport } = props;

  const renderSingleClob = (item: ModernSlaveryClobDto, index: number) => {
    const { entitySummaryCode, entitySummaryDetail, affinity } = item;
    const code: string = entitySummaryCode || t('unknown');
    const desc: string = entitySummaryDetail || t('unknown');
    const title = `${code} - ${desc}`;

    return (
      <SdgScoreClob withBorder={true} withBg={true} key={index} title={title} affinity={affinity} />
    );
  };

  const renderLegands = () => {
    const legands: ISdgData[] = [
      {
        affinity: 'negative',
        title: 'Business products at high risk of being produced by child labour or forced labour',
        withBg: true,
        size: 'small',
      },
      {
        affinity: 'warning',
        title:
          'Business products identified as at risk of being potentially produced by child labour or forced labour',
        withBg: true,
        size: 'small',
      },
      {
        affinity: 'positive',
        title:
          'Business products not identified as at risk of being produced by child labour or forced labour',
        withBg: true,
        size: 'small',
      },
    ];

    return (
      <EsgLegand
        legands={legands}
        title={'Activity check against modern slavery: child labor or forced labor'}
      />
    );
  };

  const renderContent = () => {
    if (modernSlaveryReport.length === 0) {
      return <Empty title={'There is no data available'} />;
    }

    return <Root>{modernSlaveryReport.map(renderSingleClob)}</Root>;
  };

  return (
    <SubSection title={name} isBold>
      <>
        {renderLegands()}
        {renderContent()}
      </>
    </SubSection>
  );
}
